import moment from 'moment';

export const APIAuditConstants = {
  GET_API_AUDIT_METADATA_REQUEST: 'GET_API_AUDIT_METADATA_REQUEST',
  GET_API_AUDIT_METADATA_SUCCESS: 'GET_API_AUDIT_METADATA_SUCCESS',
  GET_API_AUDIT_METADATA_FAILURE: 'GET_API_AUDIT_METADATA_FAILURE',
  GET_API_AUDIT_LOGS: 'GET_API_AUDIT_LOGS',
  GET_API_AUDIT_LOGS_REQUEST: 'GET_API_AUDIT_LOGS_REQUEST',
  GET_API_AUDIT_LOGS_SUCCESS: 'GET_API_AUDIT_LOGS_SUCCESS',
  GET_API_AUDIT_LOGS_FAILURE: 'GET_API_AUDIT_LOGS_FAILURE'
};

export const APIAuditListColumnHeaders = [
  {
    name: 'resource',
    labelKey: 'auditLogs.tableHeaders.resource'
  },
  {
    name: 'action',
    labelKey: 'auditLogs.tableHeaders.action'
  },
  {
    name: 'user',
    labelKey: 'auditLogs.tableHeaders.user'
  },
  {
    name: 'timestamp',
    labelKey: 'auditLogs.tableHeaders.timestamp'
  },
  {
    name: 'details',
    labelKey: 'auditLogs.tableHeaders.details'
  }
];

export const APIAuditListColumnSizes = [20, 30, 25, 15, 10];

export const MESSAGE = {
  noItems: 'auditLogs.messages.noItems'
};

export const ACTION_TRANSLATION_KEYS = {
  'Tag Alarms Updated': 'auditLogs.actions.tagAlarmsUpdated',
  'Bulk Alarms Updated': 'auditLogs.actions.bulkAlarmsUpdated',
  'Machine Tags Alarms Updated': 'auditLogs.actions.machineTagsAlarmsUpdated',
  'Event Definition Created': 'auditLogs.actions.eventDefinitionCreated',
  'Event Definition Updated': 'auditLogs.actions.eventDefinitionUpdated',
  'Event Definition Deleted': 'auditLogs.actions.eventDefinitionDeleted',
  'Event Definition Resources Added': 'auditLogs.actions.eventDefinitionResourcesAdded',
  'Event Definition Resource Deleted': 'auditLogs.actions.eventDefinitionResourceDeleted',
  'Event Definition Trigger Updated': 'auditLogs.actions.eventDefinitionTriggerUpdated',
  'Event Definition Subscription Created or Updated': 'auditLogs.actions.eventDefinitionSubscriptionCreatedOrUpdated',
  'Event Definition Subscription Deleted': 'auditLogs.actions.eventDefinitionSubscriptionDeleted',
  'User Created': 'auditLogs.actions.userCreated',
  'User Deleted': 'auditLogs.actions.userDeleted',
  'Account Preferences Updated': 'auditLogs.actions.accountPreferencesUpdated',
  'Bulk Sensors Updated': 'auditLogs.actions.bulkSensorsUpdated',
  'Bulk Machines Updated': 'auditLogs.actions.bulkMachinesUpdated',
  'Team Created': 'auditLogs.actions.teamCreated',
  'Report Deleted': 'auditLogs.actions.reportDeleted',
};

export const RESOURCE_TRANSLATION_KEYS = {
  accounts: 'auditLogs.resources.accounts',
  event_definition: 'auditLogs.resources.eventDefinition',
  tags: 'auditLogs.resources.tags',
  users: 'auditLogs.resources.users',
};

export const initialSearchParams = {
  resource: [],
  action: [],
  endTime: moment().toDate(),
  startTime: moment().subtract(7, 'days').toDate()
};
